<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div
          class="card_container"
          :style="{
            backgroundImage: `url(${cardBackgroundUrl})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right',
            backgroundSize: ' 136px',
          }"
        >
          <div class="row dashboard_card">
            <div class="col-lg-6 col-md-6">
              <p>{{ $t("text.cards.cards") }}</p>
            </div>
            <div class="col-lg-6 col-md-6 text-right">
              <img src="@/assets/img/wallet-grey.svg" height="40px" />
            </div>
          </div>
          <div class="dashboard_card_header_section text-center mt-4">
            <h3 class="dashboard_card_header">{{ cardsCount }}</h3>
          </div>
        </div>
        <div
          class="fuelbalance_first_row_right_section mr-3 cus_bal"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="transaction_buttons_div" style="height: 62%">
            <h4 class="text-white">{{ $t("text.cards.remisCards") }}</h4>
          </div>
        </div>
      </div>
      <section class="section__row mt-3">
        <div class="">
          <div class="">
            <div class="row top_section_row mt-4" v-show="!showLoader">
              <div class="col-md-8">
                <span>
                  <!-- {{$t('text.balance.last10Trans')}} -->
                </span>
                <span> </span>
              </div>
              <div class="col-md-4 text-right">
                <!-- <button class="show_more_button remove_text_decoration"  @click="downloadWithCSS">
                  Download Sales Report
                </button> -->
              </div>
            </div>
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :excelQueryCellInfo="excelQueryCellInfo"
              :locale="usedLang"
            >
              <e-columns>
                <e-column field="index" width="70" headerText="#"></e-column>
                <e-column
                  field="cardNumber"
                  width="200"
                  :headerText="$t('text.cards.cardNumber')"
                >
                </e-column>
                <e-column
                  field="amount"
                  width="200"
                  :headerText="$t('text.cards.amount')"
                  format="N2"
                ></e-column>
                <e-column
                  field="expiryDate"
                  width="200"
                  :headerText="$t('text.cards.expiryDate')"
                  :format="formatOptions"
                  type="date"
                ></e-column>
                <e-column
                  field="userName"
                  width="270"
                  :headerText="$t('text.cards.user')"
                ></e-column>
                <e-column
                  field="locked"
                  width="200"
                  :headerText="$t('text.cards.locked')"
                ></e-column>
                <e-column
                  :template="actionButtonsTemplate"
                  :headerText="$t('text.cards.action')"
                  width="200"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
        <div>
          <b-modal
            ref="my-modal"
            id="modal1"
            hide-footer
            :title="$t('text.balance.paymentConfirmation')"
          >
            <div class="epump-loader" style="top: 10%; left: 31%">
              <img
                src="@/assets/img/epump-logo.png"
                class="epump-loader-logo"
              />
            </div>
          </b-modal>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/Customer/MasterLayout.vue";
import backgroundUrl from "@/assets/img/online-money-transfer-isometric-wallets-with-coins_107791-121.jpg";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import VehiclesCardsActions from "@/components/TableTemplates/Customer/VehicleCards";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Vehicle Cards - Epump Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      backgroundUrl,
      cardBackgroundUrl,
      cardsCount: 0,
      showLoader: false,
      tableDataCount: 10,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      actionButtonsTemplate: function () {
        return {
          template: VehiclesCardsActions,
        };
      },
    };
  },
  mounted() {
    this.getCards();

    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    excelQueryCellInfo(args) {
      if (args.column.field == "expiryDate") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY hh:mm A");
      }
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "",
          };
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          let excelExportProperties = {
            fileName: "",
          };
          this.$refs.dataGrid.excelExport(excelExportProperties);
          break;
      }
    },
    refreshGrid() {
      if (this.$refs.dataGrid) {
        this.$refs.dataGrid.refresh();
      }
    },
    getCards() {
      this.showLoader = true;
      let grid = this.$refs.dataGrid;
      this.axios
        .get(`${configObject.apiBaseUrl}/Card/Get`, configObject.authConfig())
        .then((response) => {
          let index = 0;
          response.data.forEach((res) => {
            ++index;
            res.index = index;
          });
          this.cardsCount = response.data.length;
          sessionStorage.clear();
          localStorage.setItem("cardsList", JSON.stringify(response.data));
          this.showLoader = false;
          grid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>

<style>
@media screen and (max-width: 602px) {
}
</style>
